/*
 * @Author: owen
 * @Date: 2022-04-07 10:51:44
 * @LastEditors: owen
 * @LastEditTime: 2022-04-22 21:31:27
 * @FilePath: \app-pcweb\src\store\index.js
 */
import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/AuthModule";
import Checkout from "./modules/checkout";
import HeadPortrait from "./modules/HeadPortrait";
import { getWallet } from "@/lobby_common/api/user_gen";
import { divideAccuracy } from "@/lobby_common/utils/utils";
// import { debounce } from "@/lobby_common/utils/index.js";
// import route from "@/lobby_common/router/index"
import {
  getLocalStorage,
  getSesStorage,
  setLocalStorage,
  setSesStorage,
} from "@/lobby_common/utils/auth";
import menu from "./modules/menu";
import Exchange from "./modules/exchange";

// const debounceGetUserCoinsAsync = debounce(async function (commit) {
//   const { data, code } = await getWallet();
//   console.log("0803-getUserCoinsAsync222", code, data);
//   if (code === 0) {
//     commit("setUserCoins", data);
//   }
// }, 200);

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    keepAlivePage: [
      "Home",
      "Center",
      "hActivityPage",
      "hDistribution",
      "hNoticeCenter",
    ],
    popView: [],
    popIsShow: false,
    popFullscreen: false,
    data: {
      type: "",
    },
    historyTitle: {},
    lang: null,
    collection: [],
    unCollection: [],
    recordGame: {},
    isMobile: document.body?.offsetWidth < 768,
    packetDomain: null, // 包的信息
    packetConfig: null, // 包的其他配置信息: 登录配置等
    maildot: false,
    brandId: null,
    gameIds: [],
    tmpGameIds: [],
    pageLoding: false,
    logoLoLading: false,
    fullLayoutGame: false,
    headerHeight: 0,
    reliefFunds: {
      show: false,
      shared: false,
    },
    showEvent: false, // 显示公告
    showHNav: false,
    userCoins: {},
    taskDot: 0, // 可领取任务数
    showWithdrawGuideText: null, // 特色模块提现引导是否显示文案
    localesList: [],
    curCoin: {},
    rateList: [],
    coinExchangeRate: [],
    rateLoading: false,
    googleRobotShow: false, // google验证
    isOtherLogin: false, // 是否是异地登录
    currNavIndex: "", // h5导航栏选中index
    oldNavIndex: "", // h5导航栏选中旧index
    adsEventConfig: [], // 三方上报后台配置
    registerBtnTip: "", // 注册送金和首充活动最高奖励比例+100%做引导
    isShowTips: true, // 进游戏是否显示提示弹窗
    specialRedDot: [], // 特色模块红点
    enableExchangeTips: false,
    gameWithdrawFinish: false,
    isSkipWinConfig: false, // 是否忽略弹窗循环，用来控制是否忽略弹窗循环
    retainGiftSid: undefined, // 充值礼包的挽留礼包
  },
  mutations: {
    setRetainGiftSid(state, payload) {
      state.retainGiftSid = payload;
    },
    setSkipWinConfig(state, payload) {
      state.isSkipWinConfig = payload;
    },
    setGameWithdrawFinish(state, payload) {
      state.gameWithdrawFinish = payload;
    },
    setEnableExchangeTips(state, payload) {
      state.enableExchangeTips = payload;
    },
    setShowTips(state, payload) {
      state.isShowTips = payload;
    },
    setAdsEventConfig(state, payload) {
      state.adsEventConfig = payload;
    },
    setRegisterBtnTip(state, payload) {
      state.registerBtnTip = payload;
    },
    setCurrNavIndex(state, payload) {
      state.currNavIndex = payload;
    },
    setOldNavIndex(state, payload) {
      state.oldNavIndex = payload;
      setSesStorage("oldNavIndex", payload);
    },
    setOtherLogin(state, payload) {
      state.isOtherLogin = payload;
    },
    setGoogleRobotShow(state, payload) {
      state.googleRobotShow = payload;
    },
    taskDot(state, payload) {
      state.taskDot = payload;
    },
    setWithdrawGuideText(state, payload) {
      state.showWithdrawGuideText = payload;
    },
    setSpecialRedDot(state, payload) {
      state.specialRedDot = payload;
    },
    setUserCoins(state, payload) {
      console.log("0803-setUserCoinscommit", state, payload);
      state.userCoins = { ...payload };
    },
    setCurCoin(state, payload) {
      // console.log(payload, 'payloadpayloadpayload')
      state.curCoin = { ...payload };
      state.userCoins.selectedCoinCode = payload.coinCode;
    },
    setRateList(state, payload) {
      state.rateList = payload;
    },
    setCoinExchangeRate(state, payload) {
      state.coinExchangeRate = payload;
    },
    setRateLoading(state, payload) {
      state.rateLoading = payload;
    },
    setLocalesList(state, payload) {
      state.localesList = payload;
    },
    setReliefFunds(state, payload) {
      const reliefFunds = state.reliefFunds;
      state.reliefFunds = { ...reliefFunds, ...payload };
    },
    setShowEvent(state, payload) {
      state.showEvent = payload;
    },
    setPageLoding(state, payload) {
      state.pageLoding = payload;
    },
    setFullLayoutGame(state, payload) {
      state.fullLayoutGame = payload;
    },
    setHeaderHeight(state, payload) {
      state.headerHeight = payload;
    },
    setShowHNav(state, payload) {
      state.showHNav = payload;
    },
    setogoLoading(state, payload) {
      state.logoLoLading = payload;
    },
    setMaildot(state, payload) {
      setSesStorage("MAILDOT", payload);
      state.maildot = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
      // console.log(payload, "---------setIsMobile---------");
    },
    async setPopBox(state, payload) {
      // 弹窗拦截 1.可选流通货币只有一个时直接默认选择，不显示选流通货币弹窗
      // if (payload.views === "chooseCoin") {
      //   // 获取流通货币下拉列表接口
      //   const user_data = getLocalStorage("USER_DATA");
      //   const application_id = user_data?.application_id;
      //   if (!application_id) return;
      //   const { code, data } = await getChooseCurrency({
      //     application_id: application_id,
      //   });
      //   if (code === 0) {
      //     const list = data.list || [];
      //     if (list && list.length === 1) return false;
      //   }
      // }

      if (payload.data && payload.show) {
        payload.data["_key"] = window.crypto.randomUUID();
      } else {
        payload.data = {
          ...state.data,
          _key: state.data?._key || window.crypto.randomUUID(),
        };
      }

      state.data = payload.data;
      if (payload.show) {
        // 打开新弹窗 sort 大的排在前面
        state.historyTitle = {
          ...state.historyTitle,
          [payload.views]: payload.data?.title,
        };
        let arr = [];
        if (payload.deep) {
          arr = [
            { views: payload.views, sort: payload.sort || 0 },
            ...state.popView,
          ].sort((a, b) => b.sort - a.sort);
        } else {
          arr = [{ views: payload.views, sort: payload.sort || 0 }];
        }
        state.popView = [...arr];
        state.popIsShow = true;
      } else {
        // 删除当前view展示数组下一个view
        const index = state.popView.indexOf(payload.views);
        if (payload.views && index > -1) {
          // 删除指定view
          state.popView.splice(index, 1);
          state.popView = [...state.popView];
        } else {
          if (payload.views !== "cpfInfo") {
            // 不指定view，删除数组第一个
            state.popView.shift();
            state.popView = [...state.popView];
          }
        }
        // 数组为空才会关闭弹窗
        if (state.popView.length <= 0) {
          state.popIsShow = false;
          state.data = { type: "" };
          state.historyTitle = {};
        }
      }
    },
    setFullscreen(state, payload) {
      state.popFullscreen = payload;
    },
    setLang(state, payload) {
      state.lang = payload;
      setLocalStorage("lang", { lang: payload });
    },

    setCollection(state, payload) {
      state.collection = payload;
      // setLocalStorage("COLLECTION_GAMES", payload);
    },
    setUnCollection(state, payload) {
      state.unCollection = payload;
      // setLocalStorage("UN_COLLECTION_GAMES", payload);
    },

    setRecordGame(state, payload) {
      // console.log(payload, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
      if (localStorage.getItem("IS_LOGIN") === "true") {
        setLocalStorage("PC_CUR_GAME", payload);

        // const obj = getLocalStorage("RECORD_GAMES") || {};
        // const userSid = getLocalStorage("USER_DATA")?.sid; // 用户id
        // const arry = obj[userSid] || [];
        // let curIndex;
        // const flag = arry.some(function (item, index) {
        //   if (item.gameGroupSid === payload.gameGroupSid) {
        //     curIndex = index;
        //     return true; // 返回false
        //   }
        // });
        // const curGameGroup = { ...payload, jpInfo: {}};
        // if (!flag) {
        //   // 不存在 直接放在第一个
        //   arry.unshift(curGameGroup);
        // } else {
        //   // 存在  截取游戏对象放在第一个
        //   arry.splice(0, 0, arry.splice(curIndex, 1)[0]);
        // }
        // obj[userSid] = new Set([...[...arry].slice(0, 25)]);
        // state.recordGame[userSid] = new Set([...[...arry].slice(0, 25)]);
        // state.recordGame = { ...state.recordGame };
        // setLocalStorage("RECORD_GAMES", obj);
      }
    },

    setPacketDomain(state, payload) {
      state.packetDomain = payload;
      console.log("packetDomain set", payload);
      setLocalStorage("packetDomain", payload);
    },

    setPacketConfig(state, payload) {
      state.packetConfig = payload;
      setSesStorage("packetConfig", payload);
    },
    setHideBrandId(state, payload) {
      // 设置隐藏品牌id
      state.brandId = payload;
      // setLocalStorage("HIDE_BRAND_ID", payload);
    },
    setHideGameId(state, payload) {
      // 设置隐藏游戏id
      state.gameIds = payload || [];
      // setLocalStorage("HIDE_GAME_IDS", payload);
    },
    setHideTmpGameIds(state, payload) {
      // 设置隐藏游戏模板id
      state.tmpGameIds = payload || [];
      // setLocalStorage("HIDE_TMP_GAME_IDS", payload);
    },
  },
  actions: {
    async getUserCoinsAsync({ commit, getters }) {
      if (!getters.taken) return;
      // console.log("0803-getUserCoinsAsync111");
      // debounceGetUserCoinsAsync(commit);
      const userCoinCode = getters.user.coinCode; // 会员货币
      let userIndex = 0; // 会员货币排序
      const hasExperienceWallet =
        getters.getPacketConfig?.appConfig?.wallets?.includes(
          "EXPERIENCE_WALLET"
        ); // 应用是否开启体验彩金

      const { data, code } = await getWallet({});
      //   console.log("0803-getUserCoinsAsync222", code, data);
      if (code === 0) {
        // 将打码放到每个币种内
        let wallets = data?.wallets || [];
        const codings = data?.codings || [];
        const experienceDecayRatio = data.experienceDecayRatio
          ? Number(data.experienceDecayRatio)
          : 0;
        const experienceTime = data.experienceDecayRemainTime
          ? Number(data.experienceDecayRemainTime)
          : 0;
        const maxRate = data.maxRate ? Number(data.maxRate) : 0;

        // if(data.isExperienceWallet) {  // 体验金钱包特殊处理
        //   data.selectedCoinCode = data.selectedCoinCode + ' experience'
        // }

        localStorage.setItem("coinCode", data.selectedCoinCode);

        let experienceWalletObj = {}; // 体验彩金对象
        wallets = wallets.map((v, index) => {
          const codeObj =
            codings.find((v1) => v1.coinCode === v.coinCode) || {};
          if (v.coinCode === userCoinCode) {
            userIndex = index;
            v.isUserCoinCode = true;
            experienceWalletObj = { ...v };
            experienceWalletObj.coinCode = v.coinCode + " experience";
            experienceWalletObj.isExperienceCoinCode = true;
            experienceWalletObj.experienceCoinCode = v.coinCode;
            experienceWalletObj.experienceDecayRatio = divideAccuracy(
              experienceDecayRatio,
              2
            );
            experienceWalletObj.experienceTime = experienceTime;
            experienceWalletObj.maxRate = maxRate;
            experienceWalletObj.coinIcon = v.freeIcon || v.coinIcon;
          }
          return { ...v, ...codeObj };
        });
        // console.log(wallets, experienceWalletObj, 'fsdfgdsgdfgd')
        if (hasExperienceWallet) {
          wallets.splice(userIndex + 1, 0, experienceWalletObj);
        }
        data.wallets = [...wallets];
        data.codings = [...codings];
        commit("setUserCoins", data);
        return { data, code };
      }
    },

    async getUserCoinsWs({ commit, getters }, payload) {
      if (!getters.taken) return;
      const obj = getters.getUserCoins || {};
      const arr = obj.wallets || [];
      arr.map((v, index) => {
        if (
          v.coinCode === payload.coinCode ||
          v.experienceCoinCode === payload.coinCode
        ) {
          // console.log(payload);
          // console.log(index,  arr[index],'arr[index]')
          // Vue.set(arr, index, { ...v, ...payload });
          // console.log(arr, "arr");
          v.bonusWallet = String(payload?.bonusWallet);
          v.commissionWallet = String(payload?.commissionWallet);
          v.frozenWallet = String(payload?.frozenWallet);
          v.rechargeWallet = String(payload?.rechargeWallet);
          v.withdrawWallet = String(payload?.withdrawWallet);
          v.experienceWallet = String(payload?.experienceWallet); // 体验彩金钱包
          if (v.isExperienceCoinCode) {
            payload.coinCode = v.coinCode;
          }
          arr[index] = Object.assign(v, payload);
        }
      });
      const data = { ...obj, wallets: arr };
      commit("setUserCoins", data);
    },
  },
  getters: {
    getRetainGiftSid(state) {
      return state.retainGiftSid
    },
    getGameWithdrawFinish(state) {
      return state.gameWithdrawFinish;
    },
    getCurrNavIndex(state) {
      return state.currNavIndex;
    },
    getRegisterBtnTip(state) {
      return state.registerBtnTip;
    },
    getOldNavIndex(state) {
      return state.oldNavIndex || getSesStorage("oldNavIndex");
    },
    getEnableExchangeTips(state) {
      return state.enableExchangeTips;
    },
    getShowTips(state) {
      return state.isShowTips;
    },
    getAdsEventConfig(state) {
      return state.adsEventConfig;
    },
    getOtherLogin(state) {
      return state.isOtherLogin;
    },
    googleRobotShow(state) {
      return state.googleRobotShow;
    },
    getTaskDot(state) {
      return state.taskDot;
    },
    getShowWithdrawGuideText(state) {
      return state.showWithdrawGuideText;
    },
    getUserCoins(state) {
      return state.userCoins;
    },
    getCurCoin(state) {
      return state.curCoin;
    },
    getRateList(state) {
      return state.rateList;
    },
    getCoinExchangeRate(state) {
      return state.coinExchangeRate;
    },
    getRateLoading(state) {
      return state.rateLoading;
    },
    getReliefFunds(state) {
      return state.reliefFunds;
    },
    getLogoLoLading(state) {
      return state.logoLoLading;
    },
    getFullLayoutGame(state) {
      return state.fullLayoutGame;
    },
    getHeaderHeight(state) {
      return state.headerHeight;
    },
    getShowHNav(state) {
      return state.showHNav;
    },
    getShowEvent(state) {
      return state.showEvent;
    },
    getCountryList(state) {
      const config = state.packetConfig || getSesStorage("packetConfig");
      return config.countryList || [];
    },
    getCountry(state) {
      const config = state.packetConfig || getSesStorage("packetConfig");
      return config.curCountry || {};
    },
    getLocalesList(state) {
      return state.localesList;
    },
    getPopBoxShow(state) {
      // 获取 pop 是否显示
      return state.popIsShow;
    },
    getPopBoxView(state) {
      // 获取 pop 弹框视图
      return state.popView[0]?.views;
    },
    getFullscreen(state) {
      // 获取 pop  全屏状态
      return state.popFullscreen;
    },
    getData(state) {
      // 获取 pop 弹框数据
      return state.data;
    },
    getHistoryTitle(state) {
      // 获取 pop 弹框title数据
      return state.historyTitle;
    },
    getLang(state) {
      // 获取语言
      return state.lang || getLocalStorage("lang")?.lang || "en";
    },

    getCollection(state) {
      // 获取收藏
      return state.collection.length ? state.collection : [];
      // : getLocalStorage("COLLECTION_GAMES") || [];
    },
    getUnCollection(state) {
      // 获取收藏
      return state.unCollection.length ? state.unCollection : [];
      // : getLocalStorage("UN_COLLECTION_GAMES") || [];
    },

    // getRecordGame(state) {
    //   // 获取 游玩记录
    //   if (localStorage.getItem("IS_LOGIN") === "true") {
    //     const obj =
    //       JSON.stringify(state.recordGame) !== "{}"
    //         ? JSON.parse(JSON.stringify(state.recordGame))
    //         : getLocalStorage("RECORD_GAMES") || {};

    //     const userSid = getLocalStorage("USER_DATA")?.sid; // 用户id
    //     const arry = obj[userSid] || [];
    //     return arry;
    //   } else {
    //     return [];
    //   }
    // },
    getIsMobile(state) {
      return state.isMobile;
    },
    getPacketDomain(state) {
      console.log(
        "packetDomain get",
        state.packetDomain,
        getLocalStorage("packetDomain")
      );
      return state.packetDomain || getLocalStorage("packetDomain");
    },
    getPacketConfig(state) {
      return state.packetConfig || getSesStorage("packetConfig");
    },
    getRegisterLoginTemplateNum(state) {
      // return 6
      const config = state.packetConfig || getSesStorage("packetConfig");
      return config?.registerLoginTemplate?.registerLoginStyle || 5;
    },
    getMaildot(state) {
      // 邮件是否有未读
      return state.maildot || getSesStorage("MAILDOT");
    },
    getHideBrandId(state) {
      // 获取隐藏品牌id
      return state.brandId;
    },
    getHideGameId(state) {
      // 获取隐藏游戏id
      return state.gameIds || [];
    },
    getHideTmpGameIds(state) {
      // 获取隐藏游戏模板id
      return state.tmpGameIds || [];
    },
    getPageLoding(state) {
      return !!state.pageLoding;
    },
    getSpecialRedDot(state) {
      return state.specialRedDot;
    },
  },
  modules: {
    menu,
    auth: AuthModule,
    HeadPortrait: HeadPortrait,
    Checkout: Checkout,
    Exchange: Exchange,
  },
});
